import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function BackdropLoader(props) {

    return (
        <div>
            <Backdrop
                aria-hidden={false}
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
                open={props.openBackdrop ?? false}
            >
                <CircularProgress aria-hidden={false} color="inherit" />
            </Backdrop>
        </div>
    );
}